<template>
  <div>
      <MarkdownItVue class="md-body" :content="fvalue"></MarkdownItVue>
  </div>
</template>

<script>
const utils = require('@/api/core/utils');
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'

export default {
  name: "yesMarkdown",
  components:{
    MarkdownItVue
  },
  props: {
      formCreateInject: {
          type: Object
      },
      dataSource: String
  },
  data() {
      return {
          fvalue: '',
          fDataSource: this.dataSource
      };
  },
  methods: {
      getValue() {
          return this.fvalue;
      },
      setValue(val) {
          this.fvalue = val;
      },
      loadSourceData() {
          this.fvalue = utils.getSourceData(
              this.fDataSource
          );
      }
  }
}
</script>